import { Typography } from '@mui/material'
import React, { ComponentPropsWithoutRef } from 'react'

export function FieldError({ children }: ComponentPropsWithoutRef<'div'>) {
  return (
    <Typography variant="body2" color="error">
      {children}
    </Typography>
  )
}

FieldError.defaultProps = {
  required: false,
}
